import { RestChatService } from '@repo/network'
import { KeycloakUserInfo } from '@web/modules/core'
import { ChatInitProps } from '@web/App'

export const enableUserguiding = async (chatInitConfig: ChatInitProps, currentUser: KeycloakUserInfo) => {
  try {
    const userInfo = await RestChatService.userInfo()
    if (chatInitConfig.userGuiding && (window as any).userGuiding && currentUser && userInfo?.profile) {
      ;(window as any).userGuiding.identify(currentUser.sub, {
        email: currentUser.preferred_username,
        name: currentUser.name,
        profile: userInfo.profile
      })
    }
  } catch (e) {
    console.error('Fail to enable user guiding:\n', e)
  }
}
